import { createContext, useContext } from 'react';

export type LayoutType = 'centered' | 'split-screen' | 'full-page' | 'immersive' | null;

interface LayoutContextValue {
  layoutType: LayoutType;
}

export const LayoutContext = createContext<LayoutContextValue>({ layoutType: null });

export const useLayoutContext = () => useContext(LayoutContext);
